import { BaseApiModel } from './BaseApiModel';

export class ContractConfigColor extends BaseApiModel {
  public color: string;
  public contractId: number;
  public regulationId: number;
  public createdAt: string;
  public modifiedAt: string;
  public deletedAt: string;
}
